import React, {useState,useEffect,useRef} from "react";
import Modal from "components/global/modal";
import Button from "components/button/button";
import LoadingIndicator from "assets/svg/loading-indicator";

import { Container, Draggable, DropResult } from "@edorivai/react-smooth-dnd";
import { RxDragHandleDots2 } from "react-icons/rx";
import { formatDate,currentLang } from "utils/utils";
import { CoverPlaceholderMilestone } from "constants/images";
import { useMilestones } from "redux/modules/milestone/hooks";
import { useTranslation,Trans } from "react-i18next";

const PinnedReorder = ({hide,milestones=[],organizeByText="Pinned Milestones",profile})=>{
    console.log(milestones);
    const {http} = global.services;
    const {setPinMilestones,setResetPinned} = useMilestones()
    const [submitLoading, setLoading] = useState(false);
    const [newSort, setSort] = useState(milestones); 
    const {t} = useTranslation()
    
    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
    
        result.forEach((item, index) => {
          item.order = index;
        });
        return result;
      };
 
    const onSubmit = async ()=>{
        let payload = [...newSort].map(item => {return {id:item.id, order:item.order}})
        setLoading(true);
        try{
            let res = await http.post('public/milestones/pinned-reorder',{pinned:JSON.stringify(payload)});
            if(res.status === 202){
                setResetPinned()
                setPinMilestones({ data: newSort, total: 0 })
                hide({success:true, customName:newSort});
            }
            
        }catch(e){
            console.error(e)
        }finally{
            setLoading(false);
        }
    } 
    const onDrop = (dropResult) => {
        const { removedIndex, addedIndex } = dropResult;
    
        const reorderedItems = reorder( 
          newSort,
          removedIndex,
          addedIndex
        ); 
        setSort(reorderedItems)
        // setPreviews(reorderedItems);
      };
    const organizeBy = t('pinnedMilestones');
    return(
    <div className="modal-content">
        <Modal 
            width="w-full md:w-15/20 2md:w-11/20 lg:w-9/20 xl:w-6/20"
            contentClassName="rounded-lg overflow-auto custom-scroll"
            wrapperClassName="overflow-visible"
            footerClass="border-t border-gray">
            <div>
                <div className="w-full text-center md:text-start">
                {/* header */}
                <div className="px-8.5 py-2 mt-4 flex gap-2 items-center justify-center md:justify-start border-b border-gray">
                    <h1 className="text-2xl font-bold">{t('pinnedMilestonesTitle')}</h1>
                </div>
                <div className="px-8.5 py-2 my-2">
                {/* <div>Reorder the <span className="font-bold mb-2">{organizeBy}</span> sort by dragging up or down.</div> */}
                <Trans i18nKey="pinnedMilestoneMessage" values={{ organizeBy: t('pinnedMilestones') }}>
                    Reorder the <span className="font-bold mb-2" title={t('pinnedMilestones')}>{{organizeBy}}</span> sort by dragging up or down.  
                </Trans>
                <Container
                        groupName="3"
                        dropPlaceholder={false}
                        getGhostParent={() => document.querySelector(".modal-content")}
                        shouldAnimateDrop={() => false}
                        dragClass="tilt"
                        dragHandleSelector=".dragHandleSelector"
                        onDrop={onDrop}
                    >
                    {  newSort.map((item, index) => 
                        {
                        const {translation={}} = item; 
                        const date = formatDate(item, profile?.dateFormat,t);
                        return (
                            <Draggable key={index} className="my-1">
                                <div className="flex gap-2 items-center">
                                <div className="w-6 h-6 rounded-full text-xs flex justify-center items-center text-white bg-lightBlack">{index+1}</div>
                                <span className="draggable-item dragHandleSelector cursor-pointer">
                                    <RxDragHandleDots2 className="text-2xl color-gray dnd-handle" />
                                </span>
                                    <div className="flex-1 flex items-center truncate gap-2 border border-gray rounded-md h-14">
                                        <div className="max-h-[60px] w-[60px] bg-[#e9e9e9] flex item-center justify-center relative">
                                            {
                                                (item?.thumbnail?.webp_url || item?.thumbnail?.url) ?
                                                    <img
                                                        style={{
                                                            width: '100%',
                                                            height: '60px',
                                                            objectFit: 'contain',
                                                        }}
                                                        src={item?.thumbnail?.webp_url || item?.thumbnail?.url}
                                                        alt="Milestone"
                                                    /> :
                                                    <img
                                                        style={{
                                                            width: '40%',
                                                            height: '60px',
                                                            objectFit: 'contain',
                                                        }}
                                                        src={CoverPlaceholderMilestone}
                                                        alt="Milestone"
                                                    />
                                            }
                                        </div>
                                        <div>
                                            <div className="text-sm font-semibold max-w-[290px] truncate">{translation?.[currentLang()]?.[item.title] || item.title}</div>
                                            <div className="text-darkerGray text-7xs">{date}</div>
                                        </div>
                                    </div>  
                                </div>
                            </Draggable>
                        )}

                        )} 
                    </Container>
                </div>
                </div>
                <div className="w-full px-8.5 flex items-center justify-center md:justify-end space-x-2 border-t border-gray pt-4 py-4">
                <Button
                    buttonName={t("cancel")}
                    buttonClass="bg-thBg py-4 px-8 hover:bg-gray"
                    buttonTextClass="text-black text-sm font-semibold"
                    onClick={() => hide()}
                />
                <Button
                    key="save-btn-category"
                    buttonName={t("save")}
                    buttonClass="relative py-4 px-9 bg-primary"
                    buttonTextClass="text-white text-sm font-semibold flex items-center"
                    onClick={onSubmit}
                    loadingIcon={
                    submitLoading ? (
                        <LoadingIndicator className="text-white w-4 h-4 ml-2" />
                    ) : null
                    }
                />
                </div>
            </div>

            </Modal>
    </div>);


}

export default PinnedReorder;